import { useRef, useCallback, useEffect, useLayoutEffect } from 'react'
import { toLower } from 'lodash'

// Modifier-key sibling of useShortcut — fires on cmd/ctrl + key. Unlike
// useShortcut it must not skip text inputs (meta chords are safe while typing),
// so it stays a separate hook rather than an option on the existing one.
export const useMetaShortcut = (value, callback) => {
  const callbackRef = useRef(callback)

  useLayoutEffect(() => {
    callbackRef.current = callback
  })

  const handleKeyDown = useCallback(
    (event) => {
      if ((event.metaKey || event.ctrlKey) && toLower(event.key) === toLower(value)) {
        event.preventDefault()
        callbackRef.current(event)
      }
    },
    [value]
  )

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])
}
